<template>
  <v-data-table
    :items="items"
    :loading="loading"
    :headers="headers"
    no-data-text="No Raw Materials linked yet..."
    dense
  >
    <template v-slot:item.quantity="{ item }">
      {{ item.quantity }} {{ item.units }}
    </template>
    <template v-slot:item.rawmaterial.barcode="{ item }">
      <RawMaterialChip :rawmaterial="item.rawmaterial" />
    </template>
    <template v-slot:item.action="{ item }" v-if="isDetailed">
      <BatchRawOriginEdit
        :batchid="batchid"
        :materialid="materialid"
        :instance="item"
      />
      <BatchRawOriginDelete :id="item.id" />
    </template>
  </v-data-table>
</template>

<script>
import BatchRawOriginDelete from "./BatchRawOriginDelete";
import RawMaterialChip from "../Material/RawMaterialChip";
import BatchRawOriginEdit from "./BatchRawOriginEdit";
export default {
  name: "BatchRawOriginTable",
  components: {BatchRawOriginEdit, RawMaterialChip, BatchRawOriginDelete },
  props: {
    isDetailed: {
      type: Boolean,
      default: false,
      required: true
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    batchid: {
      type: Number,
      required: true
    },
    materialid: {
      type: Number
    }
  },
  data() {
    return {
      headers: [
        { text: "Quantity", sortable: true, value: "quantity" },
        { text: "Raw Material", sortable: true, value: "rawmaterial.barcode" },
        { text: "Actions", sortable: false, value: "action", align: "right" }
      ]
    };
  }
};
</script>
